var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 67,
    height: 67,
    rx: 18.5,
    transform: "matrix(-1 0 0 1 67 0)",
    stroke: "#22242C",
    strokeOpacity: 0.6,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.688 50.9939L38.1814 47.5616L31.5665 40.8287C30.7408 39.9883 29.9581 39.0908 29.3723 38.1259C28.6998 37.0184 28.3929 36.1272 28.4123 34.919C28.4397 33.2185 29.3935 31.5939 30.8184 30.2L32.365 28.6872L38.7076 22.4557L35.3128 19.0003L27.3655 26.8247C25.5076 28.5024 24.2704 30.5288 23.8151 32.8531C23.6651 33.6184 23.645 34.1332 23.634 34.8782C23.5801 38.5362 24.8734 41.0036 26.9744 43.1424L30.718 46.9531L34.688 50.994L34.688 50.9939Z",
    fill: "#22242C",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3843 26.8438L35.3125 19.0381L38.6698 22.4554L32.3463 28.668L32.3463 28.6681L30.7997 30.1809C29.3722 31.5773 28.4131 33.2082 28.3855 34.9186C28.3661 36.133 28.6751 37.0292 29.3494 38.1398C29.9368 39.1073 30.7211 40.0064 31.5474 40.8475L38.1436 47.5613L34.6883 50.9561L30.737 46.9344L26.9935 43.1236C24.8968 40.9892 23.6069 38.5285 23.6607 34.8786C23.6717 34.1341 23.6918 33.6212 23.8413 32.8583C24.2954 30.5404 25.5292 28.5189 27.3835 26.8446L27.3843 26.8438Z",
    stroke: "#22242C",
    strokeOpacity: 0.6,
    strokeWidth: 0.0534927
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.3f55263e348dcc71589588a5010012c7.svg";
export { ForwardRef as ReactComponent };